import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectVirtualEventSummary, selectVirtualEventProgress } from 'app/virtual-event/features/summary/summary.selectors';

@Component({
  selector: 'app-goal',
  templateUrl: './goal.component.html',
  styleUrls: ['./goal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GoalComponent implements OnInit {
  public summary$: any = this.store.pipe(select(selectVirtualEventSummary));
  public progress$: any = this.store.pipe(select(selectVirtualEventProgress));

  constructor(
    private store: Store<any>
  ) { }

  ngOnInit(): void {
  }

}
